var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-changes"},[_c('v-btn',{staticClass:"btn-back",attrs:{"to":{name: 'hotelList'}}},[_c('v-icon',[_vm._v("mdi-arrow-left")]),_vm._v(" Voltar\n    ")],1),_vm._v(" "),_c('v-container',{staticClass:"list-changes-container"},[_c('list-changes-hotel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }